<template>
  <div class="mx-0">
    <ConfirmationDialog
      ref="confirm"
      :function-yes="bindingFunction"
    ></ConfirmationDialog>
    <SimpleDialog
    title="Quedan campos obligatorios por cargar. "
    text="Revise el informe para completarlos"
    ref="mandatoryFieldsDialog">
    </SimpleDialog>
    <v-btn
      :disabled="!canEdit || loading || change"
      color="primary"
      class="mx-0"
      @click="presentar"
      > Presentar</v-btn
    >
  </div>
</template>

<script>
import ConfirmationDialog from '../../../../common/ui/ConfirmationDialog'
import SimpleDialog from '../../../../common/ui/SimpleDialog.vue'

export default {
  props: {
    canEdit: Boolean,
    complete: Boolean,
    change: Boolean
  },
  components: {
    ConfirmationDialog,
    SimpleDialog
  },

  data () {
    return {
      loading: false,
      bindingFunction: null
    }
  },

  methods: {
    presentar () {
      if (this.complete) {
        this.bindingFunction = () => {
          this.loading = true
          this.axios
            .put(`/informe-auditoria/presentar/${this.$route.params.id}`)
            .then(() => {
              this.loading = false
              this.$router.go(-1)
            })
            .catch(error => {
              this.loading = false
              this.$store.commit('setErrorMsg', error)
            })
        }
        this.$refs.confirm.openDialog()
      } else {
        this.$refs.mandatoryFieldsDialog.openDialog()
        this.$emit('click', false)
      }
    }
  }
}
</script>
